import * as React from 'react'
import { connect } from 'react-redux'
import { IDetailPageState } from '../../reducers'
import { Collection } from './collection'
import {
  sanitizedCollectionsSelector,
  ISanitizedCollections
} from '../../selectors/collections'

export interface ICollectionProps {
  collections: ISanitizedCollections
}

const ConnectedCollections = ({ collections }: ICollectionProps) => {
  return (
    <>
      {collections.map((col, idx) => {
        if (col === null) {
          return null
        }
        return (
          <React.Fragment key={idx}>
            <Collection {...col} />
          </React.Fragment>
        )
      })}
    </>
  )
}

const mapStateToProps = (state: IDetailPageState): ICollectionProps => ({
  collections: sanitizedCollectionsSelector(state)
})

export const Collections = connect(mapStateToProps)(ConnectedCollections)
